import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import validateFormPermisson from "../../../validtions/forms/permisson/edit";
import authorizedComponent from "../../../helpers/authorized-component";
import UnAuthorized from "../../partials/other/UnAuthorized";

function EditPermission() {
  const initPermission = {
    name: "",
    persian_name: "",
  };

  const history = useHistory();
  const [permission, setPermission] = useState(initPermission);
  const [message, setMessage] = useState();
  const params = useParams();
  const permissionID = params.id;

  useEffect(() => {
    getPermissionData(permissionID);
  }, []);

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const getPermissionData = async (permissionID) => {
    let permission;
    try {
      permission = await sendRequestGetPermission(permissionID);

      setPermission({
        name: permission.data.data.per_name,
        persian_name: permission.data.data.per_persian_name,
      });
    } catch (error) {
      alert(error.response.data.message);
    }
  };

  const getHeaderForRequset = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetPermission = async (PermissionID) => {
    const headersRequest = getHeaderForRequset();

    return await httpService.getRequest(
      process.env.REACT_APP_DOMAIN_API + "/v1/permission/" + PermissionID,
      headersRequest
    );
  };

  const senRequestEditPermission = async (PermissionID, name, persianName) => {
    const headersRequest = getHeaderForRequset();

    return await httpService.putRequest(
      process.env.REACT_APP_DOMAIN_API + "/v1/permission/" + PermissionID,
      {
        name: name,
        persian_name: persianName,
      },
      headersRequest
    );
  };

  const getFormData = () => {
    const name = document.getElementById("name").value;
    const persianName = document.getElementById("name-persian").value;
    return {
      name: name,
      persian_name: persianName,
    };
  };

  const editPermissionHandler = async (e) => {
    e.preventDefault();

    const formData = getFormData();
    if (validateFormPermisson(formData) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormPermisson(formData),
        class_icon: "fa fa-exclamation-triangle",
      });

      return;
    }

    const name = document.getElementById("name").value;
    const persianName = document.getElementById("name-persian").value;

    try {
      await senRequestEditPermission(permissionID, name, persianName);
      history.push("/permission/all");
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
    }
  };

  return (
    <>
      <Sidebar openItem="role-permission" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">ویرایش دسترسی</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <form onSubmit={editPermissionHandler}>
                <div className="form-group">
                  <label for="email">نام انگلیسی</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    tabIndex="1"
                    defaultValue={permission.name}
                    required
                  />
                </div>
                <div className="form-group">
                  <label for="pwd">نام فارسی</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name-persian"
                    tabIndex="2"
                    defaultValue={permission.persian_name}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-outline-primary">
                  ویرایش
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default EditPermission;
